import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { faEye, faEyeSlash, IconDefinition } from '@fortawesome/free-regular-svg-icons';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { SelectLanguageConstants } from '../../../common/components/select-lang/constants/select-lang.consts';
import { IPOSValidator } from '../../../common/validators/validators';
import { RouterConstants } from '../../../core/routing/constants/app-paths.constant';
import { CognitoCallback } from '../../../core/routing/interfaces/cognito.i';
import { AuthService } from '../../../core/routing/services/auth/auth.service';
import { CreateAccountService } from '../../../core/routing/services/createAccount/create-account.service';
import { DetailService } from '../../../core/routing/services/details/detail.service';
import { LoginService } from '../../../core/routing/services/login/login.service.ts.service';
import { AppGlobal } from '../../../core/state/app-global';
import { ConfirmRegistrationConstants } from '../confirm-registration/constants/confirm-registration.constant';
import { ForgotPwdComponent } from '../forgot-pwd/forgot-pwd.component';
import { LoginConstants } from './constants/login.constant';
import { User } from './_models/user.model';
import { GoogleAnalyticsService } from '../../google-analytics/google-analytics.service';
import { CommonService } from 'src/app/common/services/common.service';
declare let gtag: Function;
@Component({
  selector: 'iposcen-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements CognitoCallback, OnInit, OnDestroy {

  loginForm: FormGroup;
  faEye = faEye;
  faEyeSlash = faEyeSlash;
  faExclamationCircle = faExclamationCircle;
  cognitoId: String;
  alertFormat: string;
  logIn: string;
  messageString: string;
  emailAddress: string;
  requiredField: string;
  validEmailId: string;
  passwordField: string;
  forgotPassword: string;
  createAccount: string;
  createAccButton: string;
  placeholderEmail: string;
  placeholderPassword: string;
  maxlengthField: string;
  forgotPasswordHref: string;
  loginhref: string;
  pwdLength: string;
  isSubmitted = false;
  fieldTextType: boolean;
  exclamationFieldType: boolean;
  displayEye: IconDefinition;
  displayExclamation: IconDefinition;
  loginButton: boolean;
  description: string;
  closeResult: string;
  returnUrl: string;
  username: string;
  password: string;
  direction: string;
  retailerNameLabel = GlobalConstants.RETAILER_NAME_LABEL_ANALYTICS;
  loginSuccessful = GlobalConstants.LOGIN_SUCCESSFUL;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private googleAnalyticsService: GoogleAnalyticsService,
    private route: ActivatedRoute,
    private router: Router,
    private service: CreateAccountService,
    private userService: LoginService,
    private formBuilder: FormBuilder,
    private appGlobal: AppGlobal,
    private modalService: NgbModal,
    private detailService: DetailService,
    private authService: AuthService,
    private cmnService: CommonService) {
  }

  ngOnInit(): void {
    this.direction = this.cmnService.direction;
    this.displayEye = faEye;
    this.loginButton = false;
    this.description = LoginConstants.DESCRIPTION_CREATEACCOUNT;
    this.displayExclamation = faExclamationCircle;
    this.forgotPasswordHref = RouterConstants.FORGOT_PWD_LINK;
    this.maxlengthField = LoginConstants.MAXIMUM_CHAR;
    this.logIn = LoginConstants.LOGIN;
    this.pwdLength = LoginConstants.PASSWORD_MIN_LENGTH;
    this.emailAddress = LoginConstants.EMAIL_ADDRESS;
    this.placeholderEmail = LoginConstants.PLACEHOLDER_EMAIL_ADDRESS;
    this.placeholderPassword = LoginConstants.PLACEHOLDER_PASSWORD;
    this.requiredField = LoginConstants.REQUIRED_FIELD;
    this.validEmailId = LoginConstants.VALID_EMAIL_ID;
    this.passwordField = LoginConstants.PASSWORD;
    this.forgotPassword = LoginConstants.FORGOT_PASSWORD;
    this.createAccButton = LoginConstants.CREATE_ACCOUNT_BUTTON;
    this.loginhref = RouterConstants.LOGIN_PAGE_LINK;
    this.createAccount = LoginConstants.CREATE_ACCOUNT;
    const PAT_EMAIL = IPOSValidator.EMAIL;
    const PAT_PASSWORD = IPOSValidator.PASSWORD;
    sessionStorage.setItem('visitedTwoFA', 'false');
    this.loginForm = this.formBuilder.group({
      username: new FormControl({
        value: sessionStorage.getItem('email'),
        disabled: false
      },
        [Validators.required, Validators.pattern(PAT_EMAIL)]),
      password: new FormControl('', [Validators.required])
    });
    this.messageString = undefined;
    this.returnUrl = this.route.snapshot.queryParams.returnUrl || RouterConstants.HOME_PAGE_LINK;
    if (localStorage.getItem('preferredLanguage')) {
      // Get current page URL
      const currentdetailPage = window.location.href;
      const pageName = currentdetailPage.split('/');
      // Check if app running on localhost
      if (!pageName.some(ele => ele.includes('localhost'))) {
        // check if language codes are different in localstorage and loaded URL
        if (pageName[pageName.length - 2] !== localStorage.getItem('preferredLanguage')) {
          const routeLink = `/${localStorage.getItem('preferredLanguage')}/index.html`;
          location.assign(routeLink);
        }
      }
    }

    this.userService.mfaCode$.subscribe((data:string) => {
      if(data) {
        this.callMFAVerification(data);
      }
    })

    this.userService.resendMFACode$.subscribe((data: number) => {
      if(data > 0) {
        this.login(true);
      }
    })

  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  loginBtn() {
    this.loginButton = false;
    if (this.loginForm.get('username').value
      && this.loginForm.get('password').value) {
      this.loginButton = true;
    }
  }
  get formControls() { return this.loginForm.controls; }

  callMFAVerification(data: string) {
    this.userService.verifyCustomChallenge(data, this);
  }

  login(resendOtp: boolean = false) {
    sessionStorage.clear();
    this.isSubmitted = true;
    this.username = this.loginForm.get('username').value;
    let password = this.loginForm.get('password').value;
    if (this.loginForm.invalid || this.username === null || password === null) {
      return;
    }
    this.messageString = undefined;
    this.userService.authenticate(this.username, password, this, resendOtp);
    this.detailService.setLayoutToMain(false);
    this.cmnService.setRetailerListPopupFlag(true);
  }

  open(): void {
    this.modalService.open(ForgotPwdComponent);
  }

  getDismissReason(reason: any): string {
    let message: string;
    switch (reason) {
      case ModalDismissReasons.ESC: {
        message = ConfirmRegistrationConstants.DIMISS_REASON_ESC;
        break;
      }
      case ModalDismissReasons.BACKDROP_CLICK: {
        message = ConfirmRegistrationConstants.DISMISS_REASON_DROP;
        break;
      }
      default: {
        message = `with: ${reason}`;
        break;
      }
    }

    return message;
  }

  redirectToLanguage() {
    this.router.navigate([RouterConstants.SELECT_LANGUAGE_LINK, SelectLanguageConstants.CREATE_ACCOUNT]);
  }


  handleMFAStep(resendOtp: boolean) {
    if(!resendOtp) {
      sessionStorage.setItem('visitedTwoFA', 'true');
      sessionStorage.setItem('usedTwoFA', 'true');
    }
    if(!localStorage.getItem('otpSent')){
      localStorage.setItem('otpSent', '1');
    }
     this.router.navigateByUrl(GlobalConstants.TWO_FA);
  }


  cognitoCallback(message: string, result: any) {
      if (message !== undefined) { // error
        this.messageString = message;
        this.alertFormat = 'alert alert-danger';
        if (this.messageString === LoginConstants.INCORRECT_CREDDENTIALS) {
          this.messageString = LoginConstants.INCORRECT_EMAIL_PASSWORD;
        } else if (this.messageString === LoginConstants.USER_NOT_CONFIRMED) {
          this.resendCode();
          this.router.navigate([RouterConstants.CONFIRM_REGISTRATION_LINK, this.loginForm.get('username').value]);
  
        } else if (this.messageString === LoginConstants.USER_SET_PASSWORD) {
          this.router.navigate([RouterConstants.RESET_PASSWORD_LINK]);
        } else if (this.messageString === LoginConstants.USER_DISABLED) {
          this.messageString = LoginConstants.USER_DISABLED_REPLACE;
        } else {
          this.messageString = message;
        }
      } else if(result != undefined && result?.idToken?.payload['custom:status'] === 'deleted') { // user deleted
        this.messageString = LoginConstants.USER_DEACTIVATED;
        this.alertFormat = 'alert alert-danger';
      } else { // success
        this.messageString = LoginConstants.LOGGED_IN_SUCCESSFULLY;
        this.alertFormat = 'alert alert-success';
        this.handleLoginSuccess(result);
      }
    
    

  }

  resendCode(): void {
    sessionStorage.setItem('email', this.loginForm.get('username').value);
    this.service.resendCode(this.loginForm.get('username').value, this);
  }

  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
    if (this.fieldTextType) {
      this.displayEye = faEyeSlash;
    } else if (!this.fieldTextType) {
      this.displayEye = faEye;
    }
  }

  toggleExclamation() {
    this.exclamationFieldType = !this.exclamationFieldType;
  }

  handleLoginSuccess(result: any) {
    const user = new User(
      result.idToken.payload.sub,
      result.idToken.payload.email,
      result.idToken.payload.given_name,
      result.idToken.payload.family_name,
      result.idToken.payload['custom:custom:retailer_name'],
      result.idToken.payload['custom:role'],
      result.idToken.payload['custom:retailerID'],
      result.idToken.payload['custom:storeID'],
      result.idToken.payload['custom:custom:store_name'],
      result.idToken.payload['custom:custom:country'],
      result.idToken.payload['custom:partnerID'],
      result.idToken.payload['custom:partnerName']

    );

    // Set User so other componnets can subscribe to it
    this.appGlobal.setCurrentUser(user);
    // Set attributes to session storage.
    // TODO: Reduce what's being set here
    sessionStorage.setItem('userId', user.userId);
    sessionStorage.setItem('firstname', user.firstName);
    sessionStorage.setItem('lastname', user.lastName);
    sessionStorage.setItem('retailerName', user.retailerName);
    sessionStorage.setItem('userRole', user.role);
    sessionStorage.setItem('retailerId', user.retailerID);
    sessionStorage.setItem('storeID', user.storeID);
    sessionStorage.setItem('storeName', user.storeName);
    sessionStorage.setItem('location', user.location);
    sessionStorage.setItem('email', user.email);
    if (user.role === 'author') {
      sessionStorage.setItem('partnerID', user.partnerID);
      sessionStorage.setItem('partnerName', user.partnerName);
    }

    // Changes to call GetID and GetCredentialsByID APIs to get STS, which will be used for API authorization
    this.getSTS(result);

    //gtm(google tag manager)
    const retailerName = sessionStorage.getItem('retailerName');
    const retailerId = sessionStorage.getItem('retailerId');
    const userRole = sessionStorage.getItem('userRole');
    const userId = sessionStorage.getItem('userId');
    const accLanguageName = localStorage.getItem('preferredLanguageName');
    if(!sessionStorage.getItem('usedTwoFA') && localStorage.getItem('otpSent')){
      sessionStorage.setItem('usedTwoFA','true');
    }
    let used_two_fa = 0;
    let otp_sent = undefined;
    if(sessionStorage.getItem('usedTwoFA')){
       used_two_fa = 1;
       otp_sent = localStorage.getItem('otpSent');
    }
    window['dataLayer'].push({
      'user_id': userId,
      'retailer_id': retailerId,
      'login_successful': true,
      'user_role_type': userRole,
      'retailer_name': retailerName,
      'account_language': accLanguageName,
      'used_two_fa': used_two_fa,
      'otp_sent': otp_sent
    });
    if(userRole != 'regionalHQ') {
      this.googleAnalyticsService.login();
    }
  }

  getSTS(result: any) {
    this.authService.getId(result.idToken.jwtToken)
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getIdResponse => {

        this.authService.getCredentialsForIdentity(result.idToken.jwtToken, getIdResponse.IdentityId)
          .pipe(takeUntil(this.ngUnsubscribe))
          .pipe(first())
          .subscribe(getCredsForIdResponse => {
            sessionStorage.setItem('idToken', result.idToken.jwtToken);
            sessionStorage.setItem('cognitoAccessToken', result.accessToken.jwtToken);
            sessionStorage.setItem('refreshToken', result.refreshToken.token);
            sessionStorage.setItem('accessToken', getCredsForIdResponse.Credentials.SessionToken);
            sessionStorage.setItem('SecretKey', getCredsForIdResponse.Credentials.SecretKey);
            sessionStorage.setItem('AccessKeyId', getCredsForIdResponse.Credentials.AccessKeyId);
            // If there is a redirect uri present, navigate to that uri instead of home page.
            if (sessionStorage.getItem('userRole') === 'author') {
              this.router.navigate(['oem/model-sku-info']);
            } else if (sessionStorage.getItem('userRole') === GlobalConstants.DEVICE_EXECUTIVE_USER_ROLE) {
              this.router.navigate(['devices/device-dashboard']);
            } else {
               //IIT2-17330
               if(sessionStorage.getItem('userRole') === RouterConstants.REGIONAL_HQ && this.returnUrl !== '/home'){
                 this.router.navigate([RouterConstants.HOME_PAGE_LINK]);
               }else{
	                 this.router.navigate([this.returnUrl]);
               }
             }
           },
            error => {
              // do something
            });
      },
        error => {
          // do something
        });
  }
}
